// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__272Cb","left":"InfoRow_left__2hjI6"};